var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOptions = function SvgOptions(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 4,
    viewBox: "0 0 14 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66683 0.666656C2.40321 0.666656 3.00016 1.26361 3.00016 1.99999C3.00016 2.73637 2.40321 3.33332 1.66683 3.33332C0.93045 3.33332 0.333496 2.73637 0.333496 1.99999C0.333496 1.26361 0.93045 0.666656 1.66683 0.666656ZM12.3335 0.666656C13.0699 0.666656 13.6668 1.26361 13.6668 1.99999C13.6668 2.73637 13.0699 3.33332 12.3335 3.33332C11.5971 3.33332 11.0002 2.73637 11.0002 1.99999C11.0002 1.26361 11.5971 0.666656 12.3335 0.666656ZM7.00016 0.666656C7.73654 0.666656 8.3335 1.26361 8.3335 1.99999C8.3335 2.73637 7.73654 3.33332 7.00016 3.33332C6.26378 3.33332 5.66683 2.73637 5.66683 1.99999C5.66683 1.26361 6.26378 0.666656 7.00016 0.666656Z",
    fill: "#767676"
  })));
};
export { SvgOptions as ReactComponent };
export default __webpack_public_path__ + "assets/d657a652.svg";